<template>
  <error-pages-form
    :id="0"
    @submit="addErrorPage"
    @close="onClose"
  />
</template>
<script>
import ErrorPagesForm from './ErrorPagesForm.vue'

export default {
  name: 'CreateErrorPage',
  components: {
    ErrorPagesForm,
  },
  data() {
    return {
      distributionId: null,
    }
  },
  created() {
    this.distributionId = this.$route.params.id
  },
  methods: {
    addErrorPage(errorPage) {
      this.$store.dispatch('cdn/addErrorPage', {
        distributionId: this.distributionId,
        errorPage,
      }).then(() => {
        this.successToast('Error page was created')
        this.onClose()
      }).catch(error => { this.errorToast(error.response?.data?.errors[0] || 'Something went wrong while creating error page.') })
    },

    onClose() {
      this.$router.push({ name: 'distribution-error-pages', params: { id: this.distributionId } })
    },
  },
}
</script>
